export default __webpack_public_path__ + "static/media/img (2).aa1d35b0.jpg";